import React from 'react';
import {Navigate, Outlet} from 'react-router-dom'
import { USER_SESSION_KEY } from '../Constants';

const useAuth = () => {
    const user = localStorage.getItem(USER_SESSION_KEY);
    return !!user;
}

const PrivateRoutes = () => {
    const isAuth = useAuth();
    return isAuth ? <Outlet /> : <Navigate to='login' replace />;
};

export default PrivateRoutes;
